












































import { Component, Mixins } from "vue-property-decorator";
import MultiOrderableProfessionListSelector from "../selectors/MultiOrderableProfessionListSelector.vue";
import { MultiOrderableProfessionListSelectorDialogMixin } from "./mixins";

@Component({
  components: {
    MultiOrderableProfessionListSelector,
  }
})
export default class MultiOrderableProfessionListSelectorDialog extends Mixins(MultiOrderableProfessionListSelectorDialogMixin) {
}
